import type { LOAD_TYPE_KEY } from '$lib/types/load';
import { Blinds, Cpu, ToggleRight, Zap } from 'lucide-svelte';

export const DIN_MODULE_TYPES = {
	phase_cut: {
		key: 'phase_cut',
		accepted_loads: ['phase_cut'] as Array<LOAD_TYPE_KEY>,
		label: 'Phase Cut Dimmer',
		icon: Zap,
		channels: 8
	},
	relay: {
		key: 'relay',
		label: 'Relay Module',
		accepted_loads: ['relay'] as Array<LOAD_TYPE_KEY>,
		icon: ToggleRight,
		channels: 8
	},
	'1-10v': {
		key: '1-10v',
		label: '1-10V Dimmer',
		accepted_loads: ['1-10v'] as Array<LOAD_TYPE_KEY>,
		icon: Zap,
		channels: 8
	},
	curtain: {
		key: 'curtain',
		label: 'Curtain Controller',
		accepted_loads: ['curtain'] as Array<LOAD_TYPE_KEY>,
		icon: Blinds,
		channels: 4
	},
	dali_master: {
		key: 'dali_master',
		label: 'DALI Master',
		accepted_loads: ['dali-dt6', 'dali-dt8'] as Array<LOAD_TYPE_KEY>,
		icon: Cpu,
		channels: 2
	}
} as const;

export const DIN_MODULE_FORM_TYPES = {
	CREATE: 'CREATE A DIN MODULE',
	EDIT: 'EDIT A DIN MODULE'
} as const;

export const MAX_DIN_MODULE_ADDRESS = 64;

export const DIN_MODULE_ADDRESSES: readonly number[] = Array.from(
	{ length: MAX_DIN_MODULE_ADDRESS },
	(_, i) => i + 1
);

// The DIN rail address dip-switch/selector is 4 bits: 0-15 inclusive (16 slots).
export const DIN_MODULE_ADDRESS_RANGE: readonly number[] = Array.from(
	{ length: 16 },
	(_, i) => i
);

// Uniqueness is enforced per (rcu, module_type), so an address can be reused
// by a different module type on the same RCU. `moduleType` is optional so
// existing callers that only care about "any free address on this RCU" keep
// working unchanged.
export function getTakenDinAddresses(
	modules: { rcu: number; address: number; module_type?: string }[],
	rcuId: number,
	moduleType?: string
): Set<number> {
	return new Set(
		modules
			.filter((m) => m.rcu === rcuId && (moduleType == null || m.module_type === moduleType))
			.map((m) => m.address)
	);
}

export function getNextAvailableDinAddress(
	modules: { rcu: number; address: number; module_type?: string }[],
	rcuId: number,
	moduleType?: string
): number | null {
	const used = getTakenDinAddresses(modules, rcuId, moduleType);
	for (let addr = 0; addr < DIN_MODULE_ADDRESS_RANGE.length; addr++) {
		if (!used.has(addr)) return addr;
	}
	return null;
}
